import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import CustomNavbar from '../components/Navbar';
import Footer from '../components/Footer';
import MediaGalleryCard from '../components/MediaGalleryCard';
import { fetchMediaGalleries } from '../api/mediaGalleries';
import Seo from '../components/Seo';
import { PAGE_SEO } from '../seo/pages';

function MediaCentrePage() {
  const [galleries, setGalleries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    fetchMediaGalleries()
      .then((items) => {
        if (!cancelled) setGalleries(items);
      })
      .catch((error) => {
        console.error('Error fetching media galleries:', error);
        if (!cancelled) setGalleries([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="media-centre-page">
      <Seo {...PAGE_SEO.mediaCentre} />
      <CustomNavbar />

      <header className="media-centre-hero">
        <img
          src="/images/hero.avif"
          alt=""
          className="media-centre-hero__image"
        />
        <div className="media-centre-hero__overlay" aria-hidden="true" />
        <div className="media-centre-hero__content">
          <Container>
            <div className="media-centre-hero__copy">
              <h1 className="media-centre-hero__title">Media Centre</h1>
              <p className="media-centre-hero__subtitle">
                Explore QGold&apos;s latest project activities, investor presentations, site
                visits, industry events, and corporate milestones through photos and visual
                updates.
              </p>
            </div>
          </Container>
        </div>
      </header>

      <section className="media-centre-latest py-5" aria-labelledby="latest-media-heading">
        <Container>
          <h2 id="latest-media-heading" className="media-centre-latest__title">
            Latest Media
          </h2>

          {loading ? (
            <p className="media-centre-empty">Loading media galleries...</p>
          ) : galleries.length === 0 ? (
            <p className="media-centre-empty">
              Media galleries will appear here as project activities and events are
              documented.{' '}
              <Link to="/news">View latest news releases</Link>.
            </p>
          ) : (
            <div className="media-centre-grid">
              {galleries.map((gallery) => (
                <MediaGalleryCard key={gallery.slug} gallery={gallery} />
              ))}
            </div>
          )}
        </Container>
      </section>

      <Footer />
    </div>
  );
}

export default MediaCentrePage;
